import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

interface StepperProps {
    steps: string[];
    currentStep: number;
    className?: string;
}

export const Stepper = ({ steps, currentStep }: StepperProps) => {
    return (
        <div className={cn("w-full py-4 md:p-4")}>
            {/* Desktop stepper */}
            <div className="relative items-center justify-between hidden px-4 md:flex">
                {steps.map((step, index) => (
                    <div key={index} className="flex items-start w-full last:w-auto">
                        <div className="flex flex-col items-center">
                            <div className={cn(
                                "w-8 h-8 rounded-full flex items-center justify-center z-1 mb-1",
                                "border-2 transition-colors duration-200",
                                index < currentStep
                                    ? "bg-primary border-primary text-primary-foreground"
                                    : index === currentStep
                                        ? "bg-background border-primary text-primary"
                                        : "bg-background border-muted text-muted-foreground"
                            )}>
                                {index < currentStep ? (
                                    <Check className="w-4 h-4" />
                                ) : (
                                    <span className="text-sm">{index + 1}</span>
                                )}
                            </div>
                            <span className={cn(
                                "absolute top-10 text-sm font-medium text-center w-32",
                                index <= currentStep ? "text-foreground" : "text-muted-foreground"
                            )}>
                                {step}
                            </span>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={cn(
                                "h-0.5 w-full mx-4 translate-y-4",
                                index < currentStep ? "bg-primary" : "bg-secondary dark:bg-secondary-foreground"
                            )} />
                        )}
                    </div>
                ))}
            </div>

            {/* Mobile stepper */}
            <div className="flex items-center justify-between px-4 md:hidden">
                <span className="text-sm font-medium">
                    Step {currentStep + 1} of {steps.length}
                </span>
                <span className="text-sm font-medium">
                    {steps[currentStep]}
                </span>
            </div>
            <div className="mt-2 md:hidden">
                <div className="w-full h-2 rounded-full bg-muted">
                    <div
                        className="h-2 transition-all duration-200 rounded-full bg-primary"
                        style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
                    />
                </div>
            </div>
        </div>
    );
};
